# Gesture events
Gestures = {}

# Tap
Gestures.Tap = "tap"
Gestures.TapStart = "tapstart"
Gestures.TapEnd = "tapend"
Gestures.DoubleTap = "doubletap"

# Force Tap
Gestures.ForceTap = "forcetap"
Gestures.ForceTapChange = "forcetapchange"
Gestures.ForceTapStart = "forcetapstart"
Gestures.ForceTapEnd = "forcetapend"

# Press
Gestures.LongPress = "longpress"
Gestures.LongPressStart = "longpressstart"
Gestures.LongPressEnd = "longpressend"

# Swipe
Gestures.Swipe = "swipe"
Gestures.SwipeStart = "swipestart"
Gestures.SwipeEnd = "swipeend"

Gestures.SwipeUp = "swipeup"
Gestures.SwipeUpStart = "swipeupstart"
Gestures.SwipeUpEnd = "swipeupend"

Gestures.SwipeDown = "swipedown"
Gestures.SwipeDownStart = "swipedownstart"
Gestures.SwipeDownEnd = "swipedownend"

Gestures.SwipeLeft = "swipeleft"
Gestures.SwipeLeftStart = "swipeleftstart"
Gestures.SwipeLeftEnd = "swipeleftend"

Gestures.SwipeRight = "swiperight"
Gestures.SwipeRightStart = "swiperightstart"
Gestures.SwipeRightEnd = "swiperightend"

# Edge Swipe

Gestures.EdgeSwipe = "edgeswipe"
Gestures.EdgeSwipeStart = "edgeswipestart"
Gestures.EdgeSwipeEnd = "edgeswipeend"

Gestures.EdgeSwipeTop = "edgeswipetop"
Gestures.EdgeSwipeTopStart = "edgeswipetopstart"
Gestures.EdgeSwipeTopEnd = "edgeswipetopend"

Gestures.EdgeSwipeRight = "edgeswiperight"
Gestures.EdgeSwipeRightStart = "edgeswiperightstart"
Gestures.EdgeSwipeRightEnd = "edgeswiperightend"

Gestures.EdgeSwipeBottom = "edgeswipebottom"
Gestures.EdgeSwipeBottomStart = "edgeswipebottomstart"
Gestures.EdgeSwipeBottomEnd = "edgeswipebottomend"

Gestures.EdgeSwipeLeft = "edgeswipeleft"
Gestures.EdgeSwipeLeftStart = "edgeswipeleftstart"
Gestures.EdgeSwipeLeftEnd = "edgeswipeleftend"

# Pan
Gestures.Pan = "pan"
Gestures.PanStart = "panstart"
Gestures.PanEnd = "panend"
Gestures.PanLeft = "panleft"
Gestures.PanRight = "panright"
Gestures.PanUp = "panup"
Gestures.PanDown = "pandown"

# Pinch
Gestures.Pinch = "pinch"
Gestures.PinchStart = "pinchstart"
Gestures.PinchEnd = "pinchend"

# Scale
Gestures.Scale = "scale"
Gestures.ScaleStart = "scalestart"
Gestures.ScaleEnd = "scaleend"

# Rotate
Gestures.Rotate = "rotate"
Gestures.RotateStart = "rotatestart"
Gestures.RotateEnd = "rotateend"

exports.Gestures = Gestures



/** WEBPACK FOOTER **
 ** ./framer/Gestures.coffee
 **/